import { render, staticRenderFns } from "./abroad.vue?vue&type=template&id=4facdd18&scoped=true"
import script from "./abroad.vue?vue&type=script&lang=js"
export * from "./abroad.vue?vue&type=script&lang=js"
import style0 from "./abroad.vue?vue&type=style&index=0&id=4facdd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4facdd18",
  null
  
)

export default component.exports